import companyLogo from "@/assets/brand/logo.svg";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import api from "@/api/api";
import { useSidebar } from "@/context/SidebarContext.jsx";
import { capitalizeFirstLetter } from "@/utils/stringUtils.js";
import { stopImpersonation } from "@/store/authSlice.js";

const TemplateHeader = () => {
  const { t } = useTranslation();
  const [userProfile, setUserProfile] = useState("Username");
  const { toggleSidebar } = useSidebar();
  const [position, setPosition] = useState("---");
  const dispatch = useDispatch();
  const impersonator = useSelector((state) => state.auth.impersonator);

  const handleStopImpersonation = () => {
    dispatch(stopImpersonation());
    window.location.href = "/dashboard";
  };

  const fetchUser = async (profile) => {
    const response = await api.get(`/user_profiles/${profile}.json`);
    setUserProfile(response.data?.name + " " + response.data?.lastname);
    setPosition(response.data?.position);
  };

  useEffect(() => {
    const profile = sessionStorage.getItem("profile");

    fetchUser(profile);
  }, []);

  return (
    <>
      <header
        id="header"
        className="header fixed-top d-flex align-items-center"
      >
        <div className="d-flex align-items-center justify-content-between ">
          <Link to="/dashboard" className="logo d-flex align-items-center ps-4">
            <img
              src={companyLogo}
              alt={t("company name")}
              className={"img-fluid p-1"}
            />
          </Link>
          <i
            className="bi bi-list toggle-sidebar-btn"
            onClick={toggleSidebar}
          ></i>
        </div>

        <nav className="header-nav ms-auto">
          <ul className="d-flex align-items-center">
            {impersonator && (
              <li className="nav-item pe-3">
                <span className="badge bg-warning text-dark me-2">
                  <i className="bi bi-incognito me-1"></i>
                  Viendo como {impersonator.asUsername}
                </span>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-danger"
                  onClick={handleStopImpersonation}
                >
                  <i className="bi bi-box-arrow-left me-1"></i>
                  Salir de la vista
                </button>
              </li>
            )}
            <li className="nav-item d-block d-lg-none">
              <a className="nav-link nav-icon search-bar-toggle " href="#">
                <i className="bi bi-search"></i>
              </a>
            </li>
            <li className="nav-item dropdown"></li>

            <li className="nav-item dropdown">
              <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow messages"></ul>
            </li>

            <li className="nav-item dropdown pe-3">
              <a
                className="nav-link nav-profile d-flex align-items-center pe-0"
                href="#"
                data-bs-toggle="dropdown"
              >
                {/*<img src="assets/img/profile-img.jpg" alt="Profile" className="rounded-circle"/>*/}
                <span className="d-none d-md-block dropdown-toggle ps-2">
                  {userProfile}
                </span>
              </a>

              <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
                <li className="dropdown-header">
                  <h6>{userProfile}</h6>
                  <span>{position}</span>
                </li>
                <li>
                  <hr className="dropdown-divider" />
                </li>
                <li>
                  <a
                    className="dropdown-item d-flex align-items-center"
                    href="/my_profile"
                  >
                    <i className="bi bi-person"></i>
                    <span className="text-capitalize-first">
                      {t("my profile")}
                    </span>
                  </a>
                </li>
                <li>
                  <hr className="dropdown-divider" />
                </li>
                <li>
                  <Link
                    to={"/logout"}
                    className={"dropdown-item d-flex align-items-center"}
                  >
                    <i className="bi bi-box-arrow-right"></i>
                    <span>{capitalizeFirstLetter(t("sign out"))}</span>
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </header>
    </>
  );
};

export default TemplateHeader;
